import React, { useState } from "react";
import TagRow, { TagData } from "./tag-row.component";
import DisableTagModal from "./disable-tag-modal/disable-tag-modal.component";
import DeleteTagModal from "./delete-tag-modal/delete-tag-modal.component";
import NameColorTable from "../../../Common/name-color-table/name-color-table.component";
import { Flaggers } from "../../../../common/store/flaggers/flaggers.enum";
import { mockTagsData } from "./tags.mock-data";

const TagsTable = () => {
  const [tags, setTags] = useState<TagData[]>(mockTagsData);

  return (
    <NameColorTable
      data={tags}
      onDataChange={setTags}
      firstColumnLabel="Tag Name"
      disableModalFlagger={Flaggers.DisableToggleTagModalFlagger}
      deleteModalFlagger={Flaggers.DeleteTagModalFlagger}
      renderRow={(props) => (
        <TagRow
          key={props.item.id}
          tag={props.item as TagData}
          editingTagId={props.editingId}
          editingValue={props.editingValue}
          inputRef={props.inputRef}
          onTagNameClick={props.onNameClick as (tag: TagData) => void}
          onInputChange={props.onInputChange}
          onInputKeyDown={props.onInputKeyDown}
          onInputBlur={props.onInputBlur}
          onColorSelect={props.onColorSelect}
          onToggleDisable={props.onToggleDisable}
          onDelete={props.onDelete}
        />
      )}
      renderDisableModal={(props) => (
        <DisableTagModal
          {...props}
        />
      )}
      renderDeleteModal={(props) => (
        <DeleteTagModal
          {...props}
        />
      )}
    />
  );
};

export default TagsTable;
